function initVacatureAlert() {
	document.querySelectorAll(".vacature_intro-layout [data-alert-open]").forEach((form) => {
		const dialog = document.getElementById(form.dataset.alertOpen);
		if (!dialog || form.dataset.alertInit) return;
		form.dataset.alertInit = "true";

		form.addEventListener("submit", (event) => {
			event.preventDefault();
			const email = form.querySelector("input[type=email]")?.value || "";
			const field = dialog.querySelector(".gform_wrapper input[type=email]");
			if (field && email) field.value = email;
			const expertise = form.dataset.alertExpertise;
			dialog.querySelectorAll(".gform_wrapper input[type=checkbox]").forEach((box) => {
				if (expertise && box.value === expertise) box.checked = true;
			});
			dialog.showModal();
		});

		dialog.querySelector("[data-alert-close]")?.addEventListener("click", () => dialog.close());
		dialog.addEventListener("click", (event) => event.target === dialog && dialog.close());
	});
}

if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", initVacatureAlert);
} else {
	initVacatureAlert();
}
